import { changeTransactionDate, createTransaction, deleteTransaction, editTransactionAmount, } from 'actions';
import { muteAll, useFetchOld } from 'hooks';
import { useCategories } from 'hooks/useCategory';
import useRefreshAccounts from 'hooks/useRefreshAccounts';
import { useCallback, useState } from 'react';
import { useAppStore } from 'store/hooks';
import { goBackWithKey } from 'utils/navigationv6';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const strings = {
    valuationChange: 'Valuation change',
};
const useValuationChange = () => {
    const categories = useCategories();
    const refreshAccounts = useRefreshAccounts();
    const store = useAppStore();
    const navigation = useMainStackNavigation();
    const [, , , fetch] = useFetchOld(muteAll);
    const [loading, setLoading] = useState(false);
    const createValuationChange = useCallback(async (bookingDate, data, amount, keyBack, skipSuccess) => {
        setLoading(true);
        const body = {
            amount,
            categoryId: categories.internal.id,
            accountId: data.id,
            customName: strings.valuationChange,
            userId: data.userId,
            currency: data.currency,
            bookingDate,
            updateAccountBalance: true,
        };
        const res = await fetch(createTransaction(body));
        if (res) {
            refreshAccounts(data.type);
            if (!skipSuccess) {
                navigation.navigateDeprecated('Success', {
                    title: 'Done!',
                    subTitle: 'The new valuation change has been created!',
                    buttonText: 'Done',
                    onContinue: () => {
                        if (keyBack) {
                            goBackWithKey(navigation, keyBack, false);
                        }
                        else {
                            navigation.navigateDeprecated('AccountsOverview', {
                                title: 'Net Worth - Main',
                            });
                        }
                        return true;
                    },
                });
            }
        }
        setLoading(false);
    }, [categories.internal.id, refreshAccounts, fetch]);
    const deleteValuationChange = useCallback(async (transactionId, accountType) => {
        const state = store.getState();
        const previousState = {
            transactionsArray: state.transactions.transactionsArray,
            transactionDeleted: state.transactions.transactionDeleted || null,
            searchTransactions: state.transactions.searchTransactions,
        };
        navigation.goBack();
        return fetch(deleteTransaction(transactionId, previousState)).then(() => {
            refreshAccounts(accountType);
        });
    }, [refreshAccounts, fetch]);
    const editValuationChange = useCallback(async (transactionId, accountType, amount, originalAmount) => fetch(editTransactionAmount(transactionId, amount, originalAmount)).then(() => {
        refreshAccounts(accountType);
    }), [refreshAccounts, fetch]);
    const editValuationDate = useCallback(async (transaction, date, originalDate, accountType) => fetch(changeTransactionDate(transaction, date, originalDate)).then(() => {
        refreshAccounts(accountType);
    }), [refreshAccounts, fetch]);
    return {
        createValuationChange,
        deleteValuationChange,
        editValuationChange,
        editValuationDate,
        loading,
    };
};
export default useValuationChange;
